import Swiper from 'swiper/bundle';
import 'swiper/css';

function initArtcileSwiper() {
  var swipers = document.querySelectorAll('.js-article-swiper');
  var count = 0;
  if (swipers.length) {
    swipers.forEach((el, index) => {
      el.classList.add(`s${index}`);
      const heroSliders = new Swiper(`.js-article-swiper.s${index}`, {
        slidesPerView: 1,
        spaceBetween: 15,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction',
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });
    });
  }
}
export default initArtcileSwiper;
